export const screenSize = {
    phone : 719,
    tablet:839,
    tabletxl:1279,
    desktop:1439,
    desktopxl:1920,

    headerSziexs:320,
    headerSzies:740,
    headerSziem:940,
    headerSziel:1099,
}